import React from 'react'
import { IconSquareRoundedPlus } from '@tabler/icons-react';

const ActionBarUserComp = (props) => {
    return (
        <>
            <div className="d-flex align-items-center py-1">
                {/*begin::Button*/}
                <a onClick={() => props.showFormAdd()} className="btn btn-sm btn-primary"><IconSquareRoundedPlus stroke={2} /> Tambah Pengguna</a>
                {/*end::Button*/}
            </div>
        </>
    )
}

export default ActionBarUserComp
